import { Pipe, PipeTransform } from '@angular/core';
import { ClaimsService } from '@core/authentication/claims.service';
import { Claims } from '@core/authentication/claims';
import { AdviserLabelCase, AdviserLabelPipe } from './adviser-label.pipe';

@Pipe({
  name: 'adviserRole'
})
export class AdviserRolePipe implements PipeTransform {
  constructor(private claimsService: ClaimsService) {}

  transform(adviserLabelCase: AdviserLabelCase): string {
    const userRole = this.claimsService.userRole;
    if (userRole === null) {
      return this.defaultRole(adviserLabelCase);
    }
    switch (userRole) {
      case Claims.UserRoles.Adviser:
        return this.defaultRole(adviserLabelCase);
      default:
        return userRole;
    }
  }

  defaultRole(adviserLabelCase: AdviserLabelCase): string {
    const adviserLabelPipe = new AdviserLabelPipe();
    return adviserLabelPipe.transform(adviserLabelCase);
  }
}
